import { useState, useEffect, useCallback } from "react";
import { authService } from "../services/api";

export const usePermissions = () => {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPermissions = useCallback(async () => {
    try {
      const userData = await authService.getCurrentUser();
      setPermissions(userData.permissions?.split(",") || []);
    } catch (err) {
      setError(err.message);
      console.error("Error fetching permissions:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPermissions();
  }, [fetchPermissions]);

  const hasPermission = useCallback(
    (permission) => {
      return permissions.includes(permission);
    },
    [permissions]
  );

  return {
    permissions,
    hasPermission,
    loading,
    error,
    refreshPermissions: fetchPermissions,
  };
};
